/* eslint-disable react-hooks/exhaustive-deps */
import ConfigurableValues from "../config/constants";
import { reverseGeocode } from "../utils/mapbox";

export default function useLocation() {
  const { MAPBOX_TOKEN } = ConfigurableValues();

  const latLngToGeoString = async ({ latitude, longitude }) => {
    const { formattedAddress } = await reverseGeocode(
      latitude,
      longitude,
      MAPBOX_TOKEN
    );
    return formattedAddress;
  };

  const getCurrentLocation = (callback) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const { formattedAddress } = await reverseGeocode(
            latitude,
            longitude,
            MAPBOX_TOKEN
          );
          callback(null, {
            label: "Home",
            latitude,
            longitude,
            deliveryAddress: formattedAddress,
          });
        } catch (error) {
          callback(error);
        }
      },
      (error) => {
        callback(error.message);
        console.log(error.message);
      }
    );
  };

  return {
    getCurrentLocation,
    latLngToGeoString,
  };
}
